import type { AgentEdge, AgentNode } from '@saaga/shared/interfaces/agency-node.interface'
import type { FitViewOptions } from '@xyflow/react'
import { useEffect } from 'react'

import { REACT_FLOW_FIT_VIEW_ANIMATED } from './agency-flow-canvas.config'

interface UseCanvasOnChangeParams {
  nodeList: AgentNode[]
  edgeList: AgentEdge[]
  onChange?: (nodeList: AgentNode[], edgeList: AgentEdge[]) => void
}

export const useCanvasOnChange = ({
  nodeList,
  edgeList,
  onChange,
}: UseCanvasOnChangeParams): void => {
  useEffect(() => {
    onChange?.(nodeList, edgeList)
  }, [nodeList, edgeList, onChange])
}

interface UseCanvasInitialFitViewParams {
  fitView: (options?: FitViewOptions) => void
}

export const useCanvasInitialFitView = ({ fitView }: UseCanvasInitialFitViewParams): void => {
  useEffect(() => {
    const timer = setTimeout(() => fitView(REACT_FLOW_FIT_VIEW_ANIMATED), 100)
    return () => clearTimeout(timer)
  }, [fitView])
}

interface UseDeleteHandlerRefParams {
  deleteHandlerRef: React.MutableRefObject<(nodeId: string) => void>
  handleDeleteRequest: (nodeId: string) => void
}

export const useDeleteHandlerRef = ({
  deleteHandlerRef,
  handleDeleteRequest,
}: UseDeleteHandlerRefParams): void => {
  useEffect(() => {
    deleteHandlerRef.current = handleDeleteRequest
  }, [deleteHandlerRef, handleDeleteRequest])
}
